import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 404.html redirect based on subdomain
// https://github.com/rafgraph/spa-github-pages
// This script checks to see if a redirect is present in the query string,
// converts it back into the correct url and adds it to the
// browser's history using window.history.replaceState(...),
// which won't cause the browser to attempt to load the new url.
// When the single page app is loaded further down in this file,
// the correct url will be waiting in the browser's history for
// the single page app to route accordingly.
const l = window.location;
if (l.search[1] === '/' ) {
  var decoded = l.search.slice(1).split('&').map(function(s) { 
    return s.replace(/~and~/g, '&')
  }).join('?');
  console.log(l.pathname.slice(0, -1) + decoded + l.hash);
  window.history.replaceState(null, null,
    l.pathname.slice(0, -1) + decoded + l.hash
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
